'use client';

import { useTranslation } from 'react-i18next';

import { IntlBlock } from '@sola/ark-core/atoms/intl/Intl.tsx';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.tsx';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import type { ContactDoNotUpdate } from '@sola/schema/dotcom/contacts/update.ts';

import { ContactPreferenceChannel } from '../contact-preferences-form/contact-preferences-form.config.ts';

interface ContactPreferenceOptOutAlertProps {
  channel: ContactPreferenceChannel;
  className?: string;
  isBusy: boolean;
  onReactivate: (preferences: ContactDoNotUpdate['preferences']) => void;
}

export const ContactPreferenceOptOutAlert: React.FC<
  ContactPreferenceOptOutAlertProps
> = ({ channel, className, isBusy, onReactivate }) => {
  const { t } = useTranslation(['preferences']);
  const isEmail = channel === ContactPreferenceChannel.Email;

  return (
    <Alert
      className={className}
      variant="neutral"
      message={
        <IntlBlock
          i18nKey={
            isEmail
              ? 'preferences:optOutAlerts.emailMessage'
              : 'preferences:optOutAlerts.textMessage'
          }
          components={{
            strong: <strong />,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            ReactivateLink: (
              <LinkStyle inline noUnderline noPadding>
                <button
                  type="button"
                  disabled={isBusy}
                  onClick={() =>
                    onReactivate(
                      isEmail ? { doNotEmail: false } : { doNotText: false },
                    )
                  }
                >
                  {t(
                    isEmail
                      ? 'preferences:optOutAlerts.emailLink'
                      : 'preferences:optOutAlerts.textLink',
                  )}
                </button>
              </LinkStyle>
            ),
          }}
        />
      }
    />
  );
};
